var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93271 2.70177L0.880388 8.75456C0.849911 8.78511 0.828191 8.82329 0.817492 8.8651L0.146627 11.5577C0.136761 11.5977 0.137365 11.6395 0.148383 11.6792C0.159401 11.7188 0.180459 11.755 0.209524 11.7841C0.254167 11.8286 0.314612 11.8536 0.377642 11.8537C0.397086 11.8537 0.416455 11.8513 0.435312 11.8465L3.12795 11.1756C3.16982 11.1651 3.20803 11.1433 3.23851 11.1128L9.29139 5.0604L6.93271 2.70177ZM10.7908 1.87648L10.1171 1.20278C9.6668 0.752497 8.882 0.752943 8.43224 1.20278L7.60697 2.02807L9.96553 4.38661L10.7908 3.56134C11.0157 3.33652 11.1396 3.03725 11.1396 2.71897C11.1396 2.40069 11.0157 2.10142 10.7908 1.87648Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.35425a8a01b31ed3d310fd4c69d9d3e8.svg";
export { ForwardRef as ReactComponent };